import { useEffect, useState } from 'react';
import API from '../api';
import { Link } from 'react-router-dom';
import { formatTimestamp } from '../utils/timestamp-formatter';


export default function HistoryPage() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const res = await API.get('/history');
        setHistory(res.data);
      } catch (err) {
        console.error("Error fetching history:", err);
        alert('Failed to load history of changes.');
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-6xl mx-auto bg-white p-8 rounded-xl shadow-xl">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-3xl font-bold text-gray-800">History of Changes</h2>
          <Link
            to="/dashboard"
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg"
          >
            ← Back to Dashboard
          </Link>
        </div>

        {loading ? (
          <p className="text-center text-gray-600">Loading history...</p>
        ) : history.length === 0 ? (
          <p className="text-center text-gray-600">No history records found.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full table-auto border border-gray-300 text-sm">
              <thead className="bg-gray-200">
                <tr>
                  <th className="px-4 py-2 border">Timestamp</th>
                  <th className="px-4 py-2 border">Changed by</th>
                  <th className="px-4 py-2 border">Customer</th>
                  <th className="px-4 py-2 border">Field</th>
                  <th className="px-4 py-2 border">Old Value</th>
                  <th className="px-4 py-2 border">New Value</th>
                </tr>
              </thead>
              <tbody>
                {history.map((entry, idx) => (
                  <tr key={idx} className="hover:bg-gray-50">
                    <td className="px-4 py-2 border">{formatTimestamp(entry.changed_at)}</td>
                    <td className="px-4 py-2 border">{entry.name} {entry.last_name}</td>
                    <td className="px-4 py-2 border">{entry.company_name}</td>
                    <td className="px-4 py-2 border">{entry.field_name}</td>
                    <td className="px-4 py-2 border text-gray-500">{entry.old_value}</td>
                    <td className="px-4 py-2 border text-green-700">{entry.new_value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
